module.exports = __webpack_public_path__ + "static/sample(complete_-d9a2ab0ea1a80097b3ebd7a2c93104d0.mp4";